import styled from "styled-components";
export const StyledLCNText = styled.p `
  color: ${({ theme }) => theme.palette.grayDark};
  font-size: 0.8125rem;
`;
